import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { TriangleAlert } from "lucide-react";
import { ToastClose } from "../ui/toast";

const ToastCloseButton = () => {
  return <ToastClose className="absolute right-[5%] top-[30%] " />;
};

const SuccessToast = ({ description }) => {
  return (
    <div className="flex items-center gap-2 text-midnightIndigo-400 bg-midnightIndigo-100">
      <ToastCloseButton />
      <CheckCircleIcon className="w-6 h-6 " />
      <div className="mt-[2px]">{description}</div>
    </div>
  );
};

const ErrorToast = ({ description }) => {
  return (
    <div className="flex items-center gap-2 text-midnightIndigo-400">
      <ToastCloseButton />
      <TriangleAlert className="w-6 h-6" /> <div className="mt-[2px]">{description}</div>
    </div>
  );
};

const AlertToast = ({ description }) => {
  return (
    <div className="flex items-center gap-2 text-midnightIndigo-400">
      <ToastCloseButton />
      <TriangleAlert className="w-6 h-6" /> <div className="mt-[2px]">{description}</div>
    </div>
  );
};

export default function ToastBody({ description, variant }) {
  if (variant === "success") return <SuccessToast description={description} />;
  if (variant === "error") return <ErrorToast description={description} />;
  if (variant === "alert") return <AlertToast description={description} />;

  return <div>{description}</div>;

  // const fireToast = () => {
  //   toast({
  //     description: <SuccessToast description={description} />,
  //     variant: variant,
  //   });
  // };

  // return <button onClick={fireToast}>Toast</button>;
}
